import React, { useEffect } from 'react';
import Modal from '../../components/lean-eds/modal';
import { gettext } from '@eventbrite/i18n';
import { CheckoutLifecycleEventPostMessageName } from '@eventbrite/checkout-postmessage-api';

const CheckoutWidget = ({
    cartId,
    parentUrl,
    eventId,
    onClose,
    onOrderComplete,
}) => {
    const _handleOrderComplete = (event) => {
        const { data: { messageName = '', orderId } = {} } = event;

        if (
            messageName === CheckoutLifecycleEventPostMessageName.orderComplete
        ) {
            window.removeEventListener('message', _handleOrderComplete, false);
            onOrderComplete({ orderId });
        }
    };

    const _handleOnClose = () => {
        window.removeEventListener('message', _handleOrderComplete, false);
        onClose();
    };

    useEffect(() => {
        window.addEventListener('message', _handleOrderComplete, false);

        return () => {
            window.removeEventListener('message', _handleOrderComplete, false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!eventId || !cartId) {
        return null;
    }

    return (
        <Modal
            isShown={true}
            title={gettext('Checkout')}
            onClose={_handleOnClose}
            showCloseButton={true}
            height={460}
            width={720}
            primaryActionLabel={gettext('Next')}
            hideFooter={true}
        >
            <iframe
                src={`/checkout-external?eid=${eventId}&order_id=${cartId}&parent=${parentUrl}`}
                allowtransparency="true"
                frameBorder="0"
                scrolling="auto"
                width="100%"
                height="100%"
                style={{ position: 'absolute' }}
            ></iframe>
        </Modal>
    );
};

export default CheckoutWidget;
